import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => createStyles({
  icon: {
    width: 12,
    height: 12,
    marginRight: 5,
  },
  helperText: {
    display: 'flex',
  },
  helperTextError: {
    color: '#F8221A',
  },
  helperTextSuccess: {
    color: '#00AD8D',
  },
  uppercaseField: {
    '& input': {
      textTransform: 'uppercase',
    },
  },
  promoField: {
    width: '100%',
    maxWidth: 400,
  },
}), { name: 'FormPromotionCodeInput' });

export default useStyles;
